import { useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

export const MOBILE_BREAKPOINT = "sm" as const;

export function fromMobile<T>(mobile: T, desktop: T) {
  return { base: mobile, [MOBILE_BREAKPOINT]: desktop } as Record<string, T>;
}

export function useIsMobile() {
  const theme = useMantineTheme();
  return useMediaQuery(`(max-width: calc(${theme.breakpoints[MOBILE_BREAKPOINT]} - 0.01px))`);
}

export function useMobileBreakpoint() {
  return useIsMobile();
}

export function useBreakpointValue<T>(values: { base?: T; md?: T; lg?: T }) {
  const theme = useMantineTheme();

  const isMobile = useMediaQuery(`(max-width: calc(${theme.breakpoints[MOBILE_BREAKPOINT]} - 0.01px))`);
  const isTablet = useMediaQuery(
    `(min-width: ${theme.breakpoints[MOBILE_BREAKPOINT]}) and (max-width: calc(${theme.breakpoints.lg} - 0.01px))`,
  );

  if (isMobile && values.base !== undefined) return values.base;
  if (isTablet && values.md !== undefined) return values.md;
  if (values.lg !== undefined) return values.lg;
  if (values.md !== undefined) return values.md;
  return values.base;
}
